module.exports = __webpack_public_path__ + "static/line1_8-07f87c2842dea8edd1a833ea6f272750.jpg";